const endpoints = {
  tokenEndPoints: {
    adminInfo: "/info",
    adminDetails: "/details",
    walletDetails: "/admin-wallets",
    updateWalletAddress: "/admin-wallet/update",
    addWalletAddress: "/admin-wallet/add",
    deleteWalletAddress: "/admin-wallet/delete",
    updateWalletStatus: "/admin-wallet/update-status",

    withdrawalList: "/withdrawals",
    withdrawalDetails: "/withdrawal/details",
    withdrawalStatus: "/withdrawal/status",
    
    allUsers: "/user/getall",
    user: "/user",
    userDetails: "/user/details",
    updateUser: "/user/update",
    addUser: "/user/add",

    supportTicketList: "/support-enquiries",
    getSupportTicketById: "/support-enquiries/details",
    updateSupportTicketStatus: "/support-enquiries/status",
    countSupportTicketsByStatus: "/support-enquiries/stats",
    
    getSubadminList: "/subadmin/getall",
    deleteSubadmin: "/subadmin/delete",
    updateSubadmin: "/subadmin/update",
    addSubadmin: "/subadmin/add",
    detailsSubadmin: "/subadmin/details",
    
    getAllPlanTypes: "/plan/getall",
    planDetails: "/plan/details",
    updatePlan: "/plan/update",
    addPlan: "/add-plan",
    deletePlan: "/plan/delete",
    
    listAllReferrals: "/referrals",
    // getReferralDetailsByUserId: "/referrals",

    listReferrals: "/referrals",
    getReferralDetailsByUserId: "/referrals/user",
    getReferralSummary: "/referrals/summary",
    updateReferralStatus: "/referrals/user",
    getReferralTracking: "/referrals/tracking",

    allTransactions: "/all-transactions",
    transactionDetails: "/transaction/details",
    userTransactions: "/transactions/user",
    transactionStatusUpdate: "/transaction/status",

    userWalletInfo: "/user/wallet/info",
    
    subadminSignup: "/signup",
    subadminPermission: "/permissions",

    notifications: "/notifications",
    verifyKyc: "/verify-kyc",
  },
  tokenLessEndPoints: {
    login: "/signin",
  },
};

export default endpoints;
